module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    attrs: {
      "type": "warning",
      "title": "Searching & Sorting still under development",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('data-table', {
    ref: _vm.getTableRef(),
    attrs: {
      "id": _vm.getTableRef(),
      "title": _vm.title,
      "url": _vm.url,
      "table-ref": _vm.getTableRef(),
      "fields": _vm.fields,
      "hideTop": _vm.hideTop,
      "perPage": 5,
      "sort-field": ['status', 'siteName', 'upload_at', 'upload_by', 'title'],
      "showSearch": _vm.showSearch,
      "showRefresh": _vm.showRefresh,
      "searchPlaceholder": _vm.searchPlaceholder,
      "show-pagination": _vm.showPagination,
      "params": _vm.stepData
    },
    scopedSlots: _vm._u([{
      key: "file-details",
      fn: function(props) {
        return [_c('el-card', {
          attrs: {
            "shadow": "hover"
          }
        }, [_c('h4', [_c('i', {
          class: _vm.formatStatus(props.rowData.status)
        }, [_vm._v(_vm._s(props.rowData.status))]), _vm._v(":\n             " + _vm._s(props.rowData.siteName))]), _vm._v(" "), _c('b', {
          class: _vm.formatRequest(props.rowData.RTx)
        }, [_vm._v(_vm._s(props.rowData.RTx))]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(props.rowData.siteId))]), _vm._v(" "), _c('b', {
          staticClass: "pull-right"
        }, [_vm._v(_vm._s(props.rowData.shortName))])]), _vm._v(" "), _c('center', [_c('el-form', [(!props.rowData.url) ? _c('file-upload', {
          attrs: {
            "text": 'Upload ' + props.rowData.title,
            "url": _vm.getEndpoint('/upload/' +
              props.rowData.id + '/site/' +
              props.rowData.site_id + '/' + _vm.org().name),
            "delete-file-only": true,
            "after-upload": _vm.uploaded,
            "after-delete": _vm.afterDelete,
            "model": _vm.getModel(props.rowData.id),
            "type": "primary",
            "show-tooltip": true,
            "size": _vm.size,
            "additional-data": this.uploadInfo,
            "disabled": _vm.isViewOnly() || _vm.disableUpload(props.rowData)
          }
        }) : _c('div', [_c('el-row', {
          attrs: {
            "type": "flex",
            "justify": "center",
            "gutter": 12
          }
        }, [_c('el-col', {
          attrs: {
            "align": "right"
          }
        }, [_c('popup', {
          attrs: {
            "heading": 'View ' + props.rowData.title + ' (' + props.rowData.name + ')',
            "button-text": "View",
            "button-icon": "fa fa-eye",
            "button-style": "primary",
            "overide-view-only": "",
            "show-save": false
          }
        }, [_c('pdf-viewer', {
          attrs: {
            "url": _vm.getEndpoint('/file/view/' + props.rowData.url)
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "align": "left"
          }
        }, [_c('el-button', {
          attrs: {
            "type": _vm.getType(props.rowData),
            "size": "mini",
            "disabled": _vm.isViewOnly()
          },
          on: {
            "click": function($event) {
              return _vm.download(props.rowData)
            }
          }
        }, [_c('b', [_c('i', {
          staticClass: "fa fa-download"
        }), _vm._v(" Download")])])], 1)], 1), _vm._v(" "), (_vm.showFileName && _vm.isDesktop) ? _c('p', [_c('b', [_vm._v(_vm._s(props.rowData.title))]), _vm._v(" | "), _c('i', [_vm._v(_vm._s(props.rowData.name))])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
          attrs: {
            "gutter": 12
          }
        }, [_c('el-col', {
          attrs: {
            "span": 8,
            "align": "left"
          }
        }, [_vm._v("\n                File Size: "), _c('b', [_vm._v(_vm._s(_vm.formatKiloBytes(props.rowData.size)))])]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8,
            "align": "center"
          }
        }, [_vm._v("\n                Upload at: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(props.rowData.upload_at)))])]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 8,
            "align": "right"
          }
        }, [_vm._v("\n                Upload By: "), _c('b', [_vm._v(_vm._s(props.rowData.upload_by))])])], 1)], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17b032be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/FilesRequestTable.vue
// module id = 1343
// module chunks = 0